// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, objectToParams, retrieveToken } from "../../store/api";
import { BentukKerjasamaListResponse } from "./types";

import * as bentukKerjasamaActions from "./bentukKerjasama.actions";

export function* getBentukKerjasama(
  action: ReturnType<typeof bentukKerjasamaActions.getBentukKerjasamaAsync.request>
) {
  try {
    const payload = { status: action.payload.status };

    if (typeof action.payload.status === 'undefined') delete payload.status;

    const token: string = yield retrieveToken();
    const url = `${BASE_URL}bentuk-kerjasama${objectToParams(payload)}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: BentukKerjasamaListResponse = yield call(result.json.bind(result));
      yield put(bentukKerjasamaActions.getBentukKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bentukKerjasamaActions.getBentukKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(bentukKerjasamaActions.getBentukKerjasamaAsync.failure(parsed));
  }
}

export default function* bentukKerjasamaSagaGetBentukKerjasama() {
  yield takeEvery(bentukKerjasamaActions.getBentukKerjasamaAsync.request, getBentukKerjasama);
}
